module["exports"] = [
  "+43-6##-#######",
  "06##-########",
  "+436#########",
  "06##########"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/cell_phone/formats.js
// module id = 634
// module chunks = 0